import { render, staticRenderFns } from "./TheCartItemList.vue?vue&type=template&id=39532524&scoped=true&"
import script from "./TheCartItemList.vue?vue&type=script&lang=ts&"
export * from "./TheCartItemList.vue?vue&type=script&lang=ts&"
import style0 from "./TheCartItemList.vue?vue&type=style&index=0&id=39532524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39532524",
  null
  
)

export default component.exports